import { graphql } from 'gql';

export const bimActsKC2VersionGql = graphql(`
    query bimActsKC2Version(
        $order: [BimActKC2VersionDataSortInput!]
        $skip: Int
        $take: Int
        $where: BimActKC2VersionDataFilterInput
        $workOrderVersionPriceId: Long!
        $priceLevel: BimPriceLevelEnum
    ) {
        bimActsKC2Version(
            order: $order
            skip: $skip
            take: $take
            where: $where
            workOrderVersionPriceId: $workOrderVersionPriceId
            priceLevel: $priceLevel
        ) {
            pageInfo {
                hasNextPage
                hasPreviousPage
            }
            items {
                id
                calcMethod
                correctionDate
                currentPriceTotal
                workOrderVersionId
                year
                month
                number
                date
                startDate
                finishDate
                fullNumber
                isCorrection
                isInactive
                value {
                    code
                    name
                    unit
                    quantity
                    smrTotal
                    ozp
                    emm
                    zpm
                    mp
                    nr
                    sp
                    op
                    others
                    total
                    mz
                    oz
                    tzr
                }
            }
            totalCount
        }
    }
`);
